import { React, useState, useEffect } from "react";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  ProductionSet,
  DropDownSearchDraw,
} from "../../../../src/Pages/styledElements";
import { Button, Form, Input, Select, Checkbox, Col, Row, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { GlobalSet } from "../../pageStyled";
import {
  getValidMergeGroups,
  mergeGroups,
} from "../../../Services/deckleMatchServices";
import {
  fetchWorkFlowProductDetails,
  getProductsForMerging,
} from "../../../Services/productServices";
import { ModalPopup } from "../../../Components/Modal/modal";
import warning from "../../../Assets/Icons/warning.png";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import { getWorkflowSettings } from "../../../Services/workFlowSettingsServices";
import {
  lengthUnit,
  weightUnit,
  currency_List,
} from "../../../Utils/Constant/MeasurementUnitList.jsx";
import { getUnitData } from "../../../Services/measurementService";
import { getReelCoreValues } from "../../../Services/settingsServices";

const { Option } = Select;

const MergeDrawer = (props) => {
  const [form] = Form.useForm();
  const [productList, setProductList] = useState([]);
  const [mergeGroupsArray, setMergeGroupsArray] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const deckleMatchTab = [
    { label: "Standard", value: "standard" },
    { label: "Optional", value: "optional" },
  ];
  const deckleWidthUnitData = ["cm", "mm"];
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [visibleToaster, setVisibleToaster] = useState(false);
  const [visibleOrderToaster, setVisibleOrderToaster] = useState(false);
  const [orderResp, setOrderResp] = useState();
  const [selectedUnit, setSelectedUnit] = useState(deckleWidthUnitData[0]);
  const [isProductDropdownOpen, setProductDropdown] = useState(false);
  const [isRewinderDiaDropdownOpen, setRewinderDiaDropdown] = useState(false);
  const [deckleManagementSettings, setDeckleManagementSettings] = useState();
  const [unitData, setUnitData] = useState();
  const [selectedRewinderDia, setSelectedRewinderDia] = useState([]);
  const [reelCoreValues, setReelCoreValues] = useState([]);
  const [errorMessage, setErrorMessage] = useState("")
  const capitalize = (item) => item.toUpperCase();
  useEffect(() => {
    setMergeGroupsArray([]);
  }, []);

  useEffect(() => {
    (async () => {
      setMergeGroupsArray([]);
      const response = await getUnitData();
      setUnitData(response.data);
      if (props.selectedGroup) {
        let deckleMangtSettings = await getWorkflowSettings(
          "deckle_management"
        );
        setDeckleManagementSettings(deckleMangtSettings?.data?.merging);

        form.setFieldsValue({
          core_id: props?.selectedGroup?.core_id,
          reel_od: props?.selectedGroup?.reel_od,
        });
        let req = {
          grade: props.selectedGroup.product.grade,
          quality: props.selectedGroup.product.quality,
          moisture: props.selectedGroup.product.moisture,
          gsm: props.selectedGroup.product.gsm,
          burst_factor: props.selectedGroup.product.burst_factor,
        };
        // if(props.maximum_burst_factor)
        // {
        //   req['maximum_burst_factor'] = props.maximum_burst_factor;
        // }

        // if(props.minimum_burst_factor)
        // {
        //   req['minimum_burst_factor'] = props.minimum_burst_factor;
        // }

        fetchWorkFlowProductDetails(req)
          .then((resp) => {
            setProductList(resp);
          })
          .catch((err) => {});
      }
    })();
  }, [props.selectedGroup]);

  useEffect(() => {
    if (props.selectedGroup && selectedProduct.code) {
      const body = {
        id: props.selectedGroup.id,
        product: selectedProduct.code,
      };

      getValidMergeGroups(body)
        .then((resp) => {
          for (let index = 0; index < resp.data.length; index++) {
            resp.data[index]["deckleMatch"] = "standard";
          }
          setMergeGroupsArray(resp.data);

          if (resp.data.length) {
            let group = [];
            group.push(resp.data[0].id);
            setSelectedGroups(group);
          }
          if (!resp.data.length) {
            setOrderResp(resp);
            setVisibleOrderToaster(true);
            setTimeout(() => setVisibleOrderToaster(false), 3000);
          }
        })
        .catch((error) => {
          setOrderResp(error.response.data);
          setVisibleOrderToaster(true);
          setTimeout(() => setVisibleOrderToaster(false), 3000);
        });
    }
  }, [props.selectedGroup, selectedProduct]);

  useEffect(() => {
    const fetchCoreData = async () => {
      try {
        const response = await getReelCoreValues();
        setReelCoreValues(response.core_data);
        // console.log(response);
        // setLoading(false);
      } catch (error) {
        console.log(error);
        // setError(error);
        // setLoading(false);
      }
    };

    fetchCoreData();
    // console.log(reelCoreValues);
  }, []);

  const OnProductToggleSelect = () => {
    setProductDropdown((prevState) => !prevState);
  };
  const OnRewinderDiaToggleSelect = () => {
    setRewinderDiaDropdown((prevState) => !prevState);
  };
  const onSelectedUnitChange = (e) => {
    setSelectedUnit(e);
  };
  const onChangeHandlerBox = (e, group) => {
    if (e.target.checked) {
      setSelectedGroups([...selectedGroups, group.id]);
    } else {
      setSelectedGroups(selectedGroups.filter((item) => item !== group.id));
    }
  };

  const handleProduct = (e) => {
    form.setFieldsValue({ product_spec: JSON.parse(e).product_spec });
    setSelectedProduct(JSON.parse(e));
  };

  const handleRewinderDia = (e) => {
    setSelectedRewinderDia(JSON.parse(e));
  };

  const mergeHandler = () => {
    setIsVisibleModal(true);
  };
  const handleDeckleMatchChange = (e, index) => {
    let productData = [...mergeGroupsArray];
    productData[index].deckleMatch = e.target.value;
    setMergeGroupsArray(productData);
  };
  const modalClose = () => {
    setIsVisibleModal(false);
  };
  const modalConfirm = async () => {
    setIsVisibleModal(false);
    let optionalGroup = [];
    for (let index = 0; index < selectedGroups.length; index++) {
      const group = selectedGroups[index];
      let filterGroup = mergeGroupsArray.filter(
        (data) => data.id === group && data.deckleMatch === "optional"
      );
      if (filterGroup.length) {
        optionalGroup.push(filterGroup[0].id);
      }
    }
    let mergeBody;
    if (props?.convertingMachineType !== "cutting")
       mergeBody = {
      product: selectedProduct.code,
      groups: selectedGroups,
      optional_groups: optionalGroup,
      inner_dia: `${reelCoreValues[selectedRewinderDia][0]} ${reelCoreValues[selectedRewinderDia][1]}`,
    };

    const mergeBodyForCutting = {
      product: selectedProduct.code,
      groups: selectedGroups,
      optional_groups: optionalGroup,
    };
    // console.log(mergeBody);

    mergeGroups(
      props?.convertingMachineType !== "cutting"
        ? mergeBody
        : mergeBodyForCutting
    )
      .then((resp) => {
        if (resp.merged === "single") {
          setVisibleToaster(true);
          setTimeout(() => setVisibleToaster(false), 3000);
        } else {
          props.updateTable(resp);
          setSelectedGroups([]);
          form.resetFields();
          setSelectedGroups([]);
          setSelectedProduct({});
        }
      })
      .catch((err) => {
        // console.log("Error: ", err)
        setErrorMessage(err.response.data.msg);
        setVisibleToaster(true);
        setTimeout(() => setVisibleToaster(false), 3000);
      });
  };

  const onCancel = () => {
    form.resetFields();
    setSelectedProduct({});
    props.onCloseMergeOrderDrawer();
  };

  return unitData ? (
    <RightDrawerSidebar
      title={!visibleToaster && !visibleOrderToaster ? `Merge Orders` : `\b`}
      subtitle={
        !visibleToaster && !visibleOrderToaster
          ? `Weight: ${props.selectedGroup?.weight.toFixed(3)} ${
              weightUnit[props.units.weight].displayName
            }`
          : `\b`
      }
      visible={props.visible}
      onClose={() => {
        form.resetFields();
        setMergeGroupsArray([]);
        setSelectedGroups([]);
        setSelectedProduct({});
        props.onCloseMergeOrderDrawer();
      }}
    >
      <RightDrawerContainer>
        <div className="resetPassForm removePadLeft">
          <DetailFields className="marginBtnP">
            <HaberForm>
              <Form
                name="basic"
                autoComplete="off"
                className="haberLogin haberSignup"
                style={{ marginTop: "0" }}
                form={form}
              >
                <div
                  className="drawerField"
                  style={{ paddingTop: "5px", paddingBottom: "15px" }}
                >
                  <div className="titleWithText titlebytwo">
                    <h5>Group Details</h5>
                    <p>{`Product Spec: ${props.selectedGroup?.product?.product_spec}`}</p>
                    {/* <p>
                      {`Quantity: `} {props.selectedGroup?.quantity}{" "} 
                       {props?.convertingMachineType !== "cutting"
                        ? "Reels"
                        : "Sheets"} 
                    </p> */}
                  </div>
                </div>
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Merged Orders Product Name</h5>
                    <p>Final product to be produced after merging</p>
                  </div>
                  <Form.Item
                    name="Merge order product name"
                    // rules={[{ required: true }]}
                    className="dBlock"
                  >
                    <Select
                      placeholder="Product Code - Product Name"
                      suffixIcon={
                        isProductDropdownOpen ? (
                          <DropDownSearchDraw />
                        ) : (
                          <DownArrowDraw />
                        )
                      }
                      onBlur={OnProductToggleSelect}
                      onFocus={OnProductToggleSelect}
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option?.children
                          ?.toString()
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={handleProduct}
                    >
                      {productList?.map((product) => (
                        <Option
                          key={product.code}
                          value={JSON.stringify(product)}
                        >
                          {`${product.code} - ${product.name}`}
                          <br />
                          <span style={{ fontSize: "10px" }}>
                            {product.product_spec}
                          </span>
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </div>
                {props?.convertingMachineType !== "cutting" ? (
                  <div className="drawerField removeStar">
                    <div className="titleWithText">
                      <h5>Rewinder Dimensions</h5>
                      <p>The rewinder core dia.</p>
                    </div>
                    <Form.Item
                      name="Merge order rewinder dimentions"
                      // rules={[{ required: true }]}
                      className="dBlock"
                    >
                      <Select
                        placeholder="Select Rewinder Core Dia"
                        suffixIcon={
                          isRewinderDiaDropdownOpen ? (
                            <DropDownSearchDraw />
                          ) : (
                            <DownArrowDraw />
                          )
                        }
                        onBlur={OnRewinderDiaToggleSelect}
                        onFocus={OnRewinderDiaToggleSelect}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, option) =>
                          option?.children
                            ?.toString()
                            .toLowerCase()
                            .includes(input.toLowerCase())
                        }
                        onChange={handleRewinderDia}
                      >
                        {reelCoreValues.map(([value, unit], index) => (
                          <Option key={index} value={index}>
                            {`${value} ${capitalize(
                              lengthUnit[unit]?.displayName
                            )}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </div>
                ) : null}
                <div className="drawerField">
                  <div className="titleWithText">
                    <h5>Orders to merge</h5>
                    <p>Select orders to merge and produce together</p>
                  </div>
                  <div className="prod-reelset">
                    {mergeGroupsArray?.map((group, index) => {
                      return (
                        <ProductionSet>
                          <div className="prodset-header">
                            <GlobalSet>
                              <div className="checklist-address">
                                <Checkbox
                                  type="checkbox"
                                  disabled={group.id === props.selectedGroup.id}
                                  checked={selectedGroups.includes(group.id)}
                                  onChange={(e) => onChangeHandlerBox(e, group)}
                                />
                                <div className="prodleft-header">
                                  <h4 style={{textAlign: 'left'}}>{group.product_spec}</h4>
                                  <p
                                    style={{
                                      fontSize: "12px",
                                      paddingLeft: "0px",
                                      textAlign: 'left'
                                    }}
                                    
                                  >
                                    {/* <span style={{ paddingRight: "20px" }}>
                                       Qty: {`${group.quantity} Reels`}
                                       Qty: {group.quantity}{" "}
                                      {props?.convertingMachineType !==
                                      "cutting"
                                        ? "Reels"
                                        : "Sheets"}
                                    </span> */}
                                    <span style={{textAlign: 'left'}}>
                                      Weight:
                                      {`${group.weight.toFixed(3)} ${
                                        weightUnit[props.units.weight]
                                          .displayName
                                      }`}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </GlobalSet>
                          </div>
                          <div className="prodset-body">
                            {props?.convertingMachineType !== "cutting" ? (
                              <div className="prodset-dt">
                                <Col span={24}>
                                  <Row className="centerAlign  justifyCSBetween">
                                    {/* <Col span={6}>
                                      <h5>Reel OD:</h5>
                                    </Col>
                                    <Col span={6}>
                                      <p>{`${group.reel_od} CM`}</p>
                                    </Col> */}
                                    <Col span={12} style={{ display: "flex" }}>
                                      <h5>Core OD:</h5>
                                      <span
                                        style={{ marginLeft: "10px" }}
                                      >{`${group.core_id} CM`}</span>
                                    </Col>
                                    {/* <Col span={16}>
                                     
                                    </Col> */}
                                  </Row>
                                </Col>
                              </div>
                            ) : null}
                            <div className="prodset-dt">
                              <Col span={24}>
                                <Row className="centerAlign  justifyCSBetween">
                                  <Col span={6}>
                                    <h5>Orders:</h5>
                                  </Col>
                                  <Col span={6}>
                                    <p>{`${group.number_of_orders}`}</p>
                                  </Col>
                                  <Col span={8}>
                                    <h5>Priority Orders:</h5>
                                  </Col>
                                  <Col span={4}>
                                    <p>{`${group.priority_orders}`}</p>
                                  </Col>
                                </Row>
                              </Col>
                            </div>
                            <div
                              className="drawerField"
                              style={{ padding: "10px 0 0px" }}
                            >
                              <h5>Deckle Match Fulfillment</h5>
                              <div
                                className=" switchRadio twoSwitch"
                                style={{
                                  justifyContent: "center",
                                  display: "flex",
                                  marginTop: "10px",
                                  marginBottom: "10px",
                                }}
                              >
                                <Radio.Group
                                  // disabled={validateData.type ? false : true}
                                  options={deckleMatchTab}
                                  optionType="button"
                                  buttonStyle="solid"
                                  value={group.deckleMatch}
                                  onChange={(e) =>
                                    handleDeckleMatchChange(e, index)
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          {group.merged && (
                            <div className="prodset-footer">
                              <label>Status</label>
                              <span dataset="Produced">Merged Orders</span>
                            </div>
                          )}
                        </ProductionSet>
                      );
                    })}
                  </div>
                </div>
                <div
                  className="buttonFlex fixedBtm"
                  // style={{ transform: "translateY(50px)" }}
                >
                  {/* <Form.Item>
                                        <Button htmlType="submit" className="themeBtn">
                                            <Iconmoon icon="export" size={16} color="#ffffff" />
                                            Separate Orders{" "}
                                        </Button>
                                    </Form.Item> */}
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="themeBtn"
                      onClick={mergeHandler}
                      disabled={selectedGroups.length <= 1}
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />
                      Merge Orders{" "}
                    </Button>
                  </Form.Item>
                  <Form.Item>
                    <Button className="themeBtn noBg" onClick={onCancel}>
                      <Iconmoon icon="wrong" size={16} color="#ea655b" />
                      Cancel Changes{" "}
                    </Button>
                  </Form.Item>
                </div>
              </Form>
            </HaberForm>
          </DetailFields>
        </div>
        {visibleToaster && (
          <AlertContainer
            color="red toaster"
            icon={alertRed}
            msg={errorMessage}
          />
        )}
        {visibleOrderToaster && (
          <AlertContainer
            color="red toaster"
            icon={alertRed}
            msg={orderResp.msg}
          />
        )}
      </RightDrawerContainer>
      <ModalPopup visible={isVisibleModal}>
        <div className="Popup-img">
          <img src={warning} alt="Warning" />
        </div>
        <div className="Popup-content">
          <span>Merge Order ?</span>
          <p>
            The reel and core diameter of a few selected orders cannot be
            changed. You can proceed with merging of other orders. The orders
            with a fixed different reel and core diameter will be matched
            separately. Are you sure you want to continue?
          </p>
        </div>
        <div className="ant-modal-footer-section">
          <Button
            key="back"
            className="themeBtn-plane"
            onClick={() => modalClose()}
          >
            <div className="plusPopUpBorder">
              <Iconmoon
                icon="plus-sign"
                size={9}
                color="#EA655B"
                className="ant-ico-sec"
              />
            </div>
            Cancel
          </Button>

          <Button
            key="submit"
            className="themeBtn"
            onClick={() => modalConfirm()}
          >
            <Iconmoon icon="tick-mark" size={14} color="#ffff" />
            Confirm
          </Button>
        </div>
      </ModalPopup>
    </RightDrawerSidebar>
  ) : null;
};

export default MergeDrawer;
